import gsap from "gsap";

export function paylineAnimation(linesContainer, lineIndex, { duration = 1.2 } = {}) {
    const tl = gsap.timeline();
    const line = linesContainer.getLine(lineIndex);
    const filter = line?.filters?.[0];
    const revealMask = linesContainer.getRevealMask?.(lineIndex);
    const revealDuration = revealMask ? Math.min(0.18, duration * 0.35) : 0;
    const pulseDuration = Math.max(0, duration - revealDuration);

    tl.add(() => linesContainer.show(lineIndex));
    if (revealMask) {
        tl.to(revealMask.scale, {
            x: 1,
            duration: revealDuration,
            ease: "power2.out",
            onComplete: () => linesContainer.completeReveal(lineIndex),
        });
    }

    if (filter) {
        const baseStrength = filter.outerStrength;
        tl.fromTo(
            filter,
            { outerStrength: baseStrength * 0.6 },
            {
                outerStrength: baseStrength * 1.4,
                duration: pulseDuration / 2,
                ease: "sine.inOut",
                yoyo: true,
                repeat: 1,
                onComplete: () => { filter.outerStrength = baseStrength; },
            },
        );
    } else {
        tl.to({}, { duration: pulseDuration });
    }

    tl.add(() => {
        linesContainer.completeReveal(lineIndex);
        linesContainer.hide(lineIndex);
    });
    return tl;
}
